import { Button, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect, useState } from 'react';
import './login.css';
import { useForm } from 'react-hook-form';
import { json, useNavigate } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import TextFieldComponent from '../../components/TextField/TextField';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function ForgotPassword() {
	let navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [waitCssImg, setWaitCssImg] = useState(true);
	const [department, setDepartment] = useState('');
	const [user, setUser] = useState('');

	const { register, formState: { errors }, handleSubmit, setError, setValue } = useForm({
		defaultValues: {
			department: localStorage.getItem('department'),
		}
	});

	const onSubmit = () => {
		setLoading(true);
		const body = {
			"email": user
		}
		const url = `https://${department}.${process.env.REACT_APP_FIREHOUSE_API_URL}/forgetPasswordEmail`
		axios.post(url, body)
			.then(response => {
				localStorage.setItem('email', user)
				toast.success(response?.data?.message)
				navigate('/verify-otp');
			})
			.catch((error) => {
				setLoading(false);
				toast.error(
					error?.response?.status === 403
						? error?.response?.data?.message
						: error?.response?.data
				);
			});
	};

	useEffect(() => {
		const storedDepartment = localStorage.getItem('department');
		if (storedDepartment) {
			setDepartment(storedDepartment);
		}
	}, []);

	return (
		<>
			<img src='/images/main-login-img-new.png' className='d-none' onLoad={() => setWaitCssImg(false)} />
			<div className='main-login' style={{ visibility: waitCssImg ? 'hidden' : 'visible' }}>
				<div className='login-content-box'>
					<div className='login-content'>

						<form onSubmit={handleSubmit(onSubmit)} className='login-width flex-grow-1 '>
							<div className='login-box'>
								<Grid container rowSpacing={2} columnSpacing={{ xs: 12, sm: 2, md: 3 }}>

									<Grid xs={12}>
										<Box sx={{ my: 2 }} >
											<img className='w-100 mb-3' src='/images/logo.svg' />
										</Box>

										<TextFieldComponent
											register={register('department', { required: "Department name is required" })}
											placeholder="Enter your department"
											label="Department"
											onChange={(e) => setDepartment(e.target.value)}
											endAdornment={
												<InputAdornment position="end">
													<img src="/images/department.svg" alt="icon" style={{ marginRight: "5px" }} />
												</InputAdornment>
											}
										/>
										{errors.department && <p style={{ color: 'red' }}>{errors.department?.message}</p>}
									</Grid>

									<Grid xs={12}>
										<TextFieldComponent
											register={register('email', { required: "Email or Username is required" })}
											autoFocus
											placeholder="Enter your email or username"
											label="Email / Username"
											onChange={(e) => setUser(e.target.value)}
											endAdornment={
												<InputAdornment position="end">
													<img src="/images/user-name.svg" alt="icon" />
												</InputAdornment>
											}
										/>
										{errors.email && <p style={{ color: 'red' }}>{errors.email?.message}</p>}
									</Grid>

									<Grid xs={12}>
										<Box sx={{ my: 2 }}>
											<Button
												className='rounded-5 text-capitalize login-button'
												type='submit'
												fullWidth={true}
												variant="contained"
												color='error'
												disabled={loading}
												onClick={() => {
													if (department != '') {
														localStorage.setItem("department", department);
													}
												}}
											>
												{loading ? 'Loading' : 'Submit'}
											</Button>
										</Box>
									</Grid>
								</Grid>
							</div>
						</form>

						<Grid className='flex-grow-1 text-white d-flex align-items-end'>
							<p>
								Copyright <a className='textfeild_white' target='_blank' href='https://247software.cloud'>247software.cloud</a> 2023
							</p>
						</Grid>
					</div>
				</div>
			</div>
		</>
	);
}
